import React from "react";
import {css, Theme} from "@emotion/react";

import {elevation} from "@pg-design/elevation";
import {borderRadius, display, mb, mr, onDesktop, p, truncateMultiline} from "@pg-design/helpers-css";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";

interface IProps {
    className?: string;
    article: {
        author: {
            name: string;
        };
        date_published: string | null;
        excerpt: string;
        gallery: (
            | {
                  image: {
                      g_img_349x239: string;
                      g_img_206x206: string;
                      g_img_440x292: string;
                      g_img_572x315: string;
                  };
              }
            | undefined
        )[];
        id: number;
        slug: string;
        title: string;
        lead: string | null;
    };
}

export const BlogFeaturedCard = (props: IProps) => {
    const {article} = props;
    const articleLink = rpAppLink.article.detail({
        articleSlug: article.slug,
        articleId: article.id
    });
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const blogCardHandler = () => {
        window.open(articleLink, responsiveLinkTarget);
    };
    return (
        <div className={props.className} css={articleListBox} onClick={blogCardHandler}>
            {article.gallery[0]?.image && (
                <Picture
                    css={picture}
                    sources={[
                        {minWidthPX: 0, src: article.gallery[0].image.g_img_349x239, width: 206, height: 206},
                        {minWidthPX: 360, src: article.gallery[0].image.g_img_572x315, width: 572, height: 315}
                    ]}
                    alt={article.title}
                />
            )}

            <div css={[p(4)]}>
                <Text css={mb(2)} as="div" variant="info_txt_2">
                    <div css={[display("inline-block"), mr(3)]}>{formatDate(article.date_published, dateTimeFormat.shortDate)}</div>
                    <div css={[display("inline-block")]}>{article.author.name}</div>
                </Text>

                <a className={props.className} href={articleLink} target={responsiveLinkTarget} css={link}>
                    <Text css={onDesktop(mb(2))} as="h2" variant="headline_4">
                        {article.title}
                    </Text>
                </a>
                <Text css={[display("none"), onDesktop(display("block"), truncateMultiline(4))]} variant="body_copy_1">
                    {article.lead}
                </Text>
            </div>
        </div>
    );
};

export const articleListBox = (theme: Theme) => css`
    ${elevation(2)};
    ${borderRadius(2)}
    background-color: #fff;

    &:hover {
        color: ${theme.colors.secondary};
        text-decoration: none;
        cursor: pointer;
    }

    max-width: 57.2rem;

    ${onDesktop(css`
        width: 100%;
        display: flex;
        flex-direction: row;
        overflow: hidden;
        max-width: unset;
    `)}
`;

const link = (theme: Theme) => css`
    &:visited,
    &:hover,
    &:focus,
    &:active {
        color: ${theme.colors.secondary};
        text-decoration: none;
    }
`;

const picture = css`
    overflow: hidden;
    flex-shrink: 0;
    ${borderRadius(2, 2, 0, 0)};

    ${onDesktop(css`
        ${borderRadius(2, 0, 0, 2)}
    `)};
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {elevation} from "@pg-design/elevation";
import {borderRadius, display, mb, mr, onDesktop, p, truncateMultiline} from "@pg-design/helpers-css";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";

interface IProps {
    className?: string;
    article: {
        author: {
            name: string;
        };
        date_published: string | null;
        excerpt: string;
        gallery: (
            | {
                  image: {
                      g_img_349x239: string;
                      g_img_206x206: string;
                      g_img_440x292: string;
                      g_img_572x315: string;
                  };
              }
            | undefined
        )[];
        id: number;
        slug: string;
        title: string;
        lead: string | null;
    };
}

export const BlogFeaturedCard = (props: IProps) => {
    const {article} = props;
    const articleLink = rpAppLink.article.detail({
        articleSlug: article.slug,
        articleId: article.id
    });
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const blogCardHandler = () => {
        window.open(articleLink, responsiveLinkTarget);
    };
    return (
        <div className={props.className} css={articleListBox} onClick={blogCardHandler}>
            {article.gallery[0]?.image && (
                <Picture
                    css={picture}
                    sources={[
                        {minWidthPX: 0, src: article.gallery[0].image.g_img_349x239, width: 206, height: 206},
                        {minWidthPX: 360, src: article.gallery[0].image.g_img_572x315, width: 572, height: 315}
                    ]}
                    alt={article.title}
                />
            )}

            <div css={[p(4)]}>
                <Text css={mb(2)} as="div" variant="info_txt_2">
                    <div css={[display("inline-block"), mr(3)]}>{formatDate(article.date_published, dateTimeFormat.shortDate)}</div>
                    <div css={[display("inline-block")]}>{article.author.name}</div>
                </Text>

                <a className={props.className} href={articleLink} target={responsiveLinkTarget} css={link}>
                    <Text css={onDesktop(mb(2))} as="h2" variant="headline_4">
                        {article.title}
                    </Text>
                </a>
                <Text css={[display("none"), onDesktop(display("block"), truncateMultiline(4))]} variant="body_copy_1">
                    {article.lead}
                </Text>
            </div>
        </div>
    );
};

export const articleListBox = (theme: Theme) => css`
    ${elevation(2)};
    ${borderRadius(2)}
    background-color: #fff;

    &:hover {
        color: ${theme.colors.secondary};
        text-decoration: none;
        cursor: pointer;
    }

    max-width: 57.2rem;

    ${onDesktop(css`
        width: 100%;
        display: flex;
        flex-direction: row;
        overflow: hidden;
        max-width: unset;
    `)}
`;

const link = (theme: Theme) => css`
    &:visited,
    &:hover,
    &:focus,
    &:active {
        color: ${theme.colors.secondary};
        text-decoration: none;
    }
`;

const picture = css`
    overflow: hidden;
    flex-shrink: 0;
    ${borderRadius(2, 2, 0, 0)};

    ${onDesktop(css`
        ${borderRadius(2, 0, 0, 2)}
    `)};
`;
